import { writable } from 'svelte/store';

export type ApplicationMode = 'classic' | 'neighbor' | 'dataselection' | 'checkout';

/**
 * Which way of building a selection has the screen.
 *
 * Classic is where the app opens, and classic opens on the guided doors — see
 * `guidedActive` and `guidedStep` in `$lib/stores/guided`.
 *
 * There was a fifth mode, 'welcome', and it was the default: a marketing panel
 * with a feature list and two buttons, shown before the customer could do
 * anything. The layout already flipped it to classic on mount for the root
 * path, so what it produced was a screen nobody had asked to see, on the way to
 * the screen they had. The door question is the front door and does the same
 * job better, because answering it is progress rather than dismissal.
 */
export const applicationMode = writable<ApplicationMode>('classic');
